// extracted by mini-css-extract-plugin
module.exports = {"debug":"CreateReminder_debug__3ACTv","link":"CreateReminder_link__3pHuf"};